module.exports = __webpack_public_path__ + "static/media/MAKEUP.82320ad7.png";